import { render, staticRenderFns } from "./ImageComp.vue?vue&type=template&id=3a18226c&scoped=true&"
import script from "./ImageComp.vue?vue&type=script&lang=js&"
export * from "./ImageComp.vue?vue&type=script&lang=js&"
import style0 from "./ImageComp.vue?vue&type=style&index=0&id=3a18226c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18226c",
  null
  
)

export default component.exports